// Pure context module — no side effects, no API imports. Kept separate from
// AgentContext.tsx so consumers (Storybook mocks, tests) can grab the context
// and hook without pulling in agentApi's fetch/SSE code at module-evaluation
// time.

import { createContext, useContext } from 'react';
import type { AgentState, AgentAction, AgentSettings, CodeBlock, CodeCheckpoint } from './types';

export interface AgentContextValue {
  state: AgentState;
  dispatch: React.Dispatch<AgentAction>;
  sendMessage: (content: string) => Promise<void>;
  clearHistory: () => void;
  applyCode: (codeBlock: CodeBlock) => Promise<void>;
  revertCheckpoint: (checkpoint: CodeCheckpoint) => Promise<void>;
  updateSettings: (settings: Partial<AgentSettings>) => void;
  checkConnection: () => Promise<void>;
}

export const AgentContext = createContext<AgentContextValue | null>(null);

export function useAgent(): AgentContextValue {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error('useAgent must be used within an AgentProvider');
  }
  return context;
}
